import React from "react";
import PropTypes from "prop-types";
import {useWillPipe} from "@morningtrain/react-helpers";
import {Operation} from "@morningtrain/resources";
import {Env} from "@morningtrain/helpers";
import {useRouter} from "../hooks";
import {useParameterDecoder} from "@morningtrain/react-resources";

function NavigateOnPipe(props) {

    const {route, href, routeParameters} = props;

    const router = useRouter();

    const parameterDecoder = useParameterDecoder();

    const shouldOpenInNewTab = (e) => {

        if (
            props.newTab ||
            e.ctrlKey ||
            e.shiftKey ||
            e.metaKey || // apple
            (e.button && e.button == 1) // middle click, >IE9 + everyone else
        ) {
            return true;
        }

        return false;
    }

    const shouldPreventDefault = (e) => {

        if(shouldOpenInNewTab(e)) {
            return false;
        }

        if (
            props.disableRouting === true ||
            differentNamespace()
        ) {
            return false;
        }

        return true;
    }

    const differentNamespace = () => {
        if (!route) return true;

        const operation = Operation.fromRoute(route);

        return Env.get('page.namespace') !== operation.getEnv('namespace');
    }

    useWillPipe((payload) => {
        return new Promise((resolve, reject) => {

            const {clickEvent} = payload;

            const _shouldNavigate = (!clickEvent || shouldPreventDefault(clickEvent)) && !!route;
            const _shouldOpenInNewTab = !!clickEvent && shouldOpenInNewTab(clickEvent);

            if (_shouldNavigate) {
                router.navigate(route, parameterDecoder(routeParameters, {payload: payload}));
            } else {

                const url = !!href ? href : router.route(route, parameterDecoder(routeParameters, {payload: payload}));

                if(_shouldOpenInNewTab) {
                    window.open(url);
                } else {
                    location.href = url;
                }
            }

            resolve(payload);
        });
    }, [route, routeParameters, href]);

    return null;
}

NavigateOnPipe.defaultProps = {
    href: null,
    route: null,
    routeParameters: null,
    disableRouting: false,
    newTab: false,
};

NavigateOnPipe.propTypes = {
    href: PropTypes.string,
    route: PropTypes.string,
    routeParameters: PropTypes.object,
    disableRouting: PropTypes.bool,
    newTab: PropTypes.bool,
};

export default NavigateOnPipe;
